import { ViewStream } from "spyne";
import { ModalWindowTraits } from "traits/modal-window-traits";
import { UiModalWindowContent } from "components/ui/ui-modal-window-content";
import { UiModalWindowContentTOS } from 'components/ui/ui-modal-window-content-tos';

export class UIModalWindowContainer extends ViewStream {
  constructor(props = {}) {
    props.id = "modal-window-container";
    props.traits = [ModalWindowTraits];
    props.channels = ["CHANNEL_MODAL_WINDOW"];
    props.template = require("./templates/ui-modal-window-container.tmpl.html");

    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
        ["CHANNEL_MODAL_WINDOW_LAUNCH_TOS_EVENT", "onModalWindowTOS"],
        ["CHANNEL_MODAL_WINDOW_CHANGE_EVENT", "onModalWindowChange"],
        ["CHANNEL_MODAL_SUCCESS_EVENT", "onModalWindowSuccess"],
        ["CHANNEL_MODAL_WINDOW_MESSAGE_EVENT", "onModalMessageEvent"],
        ["CHANNEL_MODAL_WINDOW_CLOSE_EVENT", "onCloseWindowEvent"]
    ];
  }


  onCloseWindowEvent(e){

    this.props.el$.toggleClass("reveal", false);
  }

  onModalMessageEvent(e){
    const {  isOpenModal, modalType, iconClass, desc, title } = e.payload;
    //console.log("ADDED MODAL WINDOW1",e);
    const data = {iconClass, desc, title};
    this.props.el$.toggleClass("reveal", isOpenModal);
    this.addMessageState();

   //console.log("DATA MODAL MESSAGE ",{modalType, iconClass, title})

    if (isOpenModal === true) {
      this.appendView(
          new UiModalWindowContent({ modalType, data }),
          "#modal-window-container-holder",
      );

      //console.log("ADDED MODAL WINDOW",e);
    }
  }



  onModalWindowSuccess(e){
    const {  isOpenModal, modalType } = e.payload;
   //console.log("ADDED MODAL WINDOW1",e);
    const data = {};
    this.props.el$.toggleClass("reveal", isOpenModal);
    this.addMessageState();

    if (isOpenModal === true) {
      this.appendView(
          new UiModalWindowContent({ modalType, data }),
          "#modal-window-container-holder",
      );

     //console.log("ADDED MODAL WINDOW",e);
    }
  }

  addMessageState(bool=true){
    this.props.el$.toggleClass('modal-message', bool);
  }

  onModalWindowTOS(e) {
    const { openModal, isOpenModal, modalType } = e.payload;


    this.props.el$.toggleClass("reveal", isOpenModal);

    if (isOpenModal === true) {
      this.appendView(
          new UiModalWindowContentTOS(),
          "#modal-window-container-holder",
      );
    }
  }


  onModalWindowChange(e) {
    const { openModal, isOpenModal, modalType } = e.payload;

   //console.log("open modal ",e);

    const data = this.modalWindow$GetDataByAttribute(modalType);
    this.addMessageState(false);

    this.props.el$.toggleClass("reveal", isOpenModal);

    if (isOpenModal === true) {
      this.appendView(
        new UiModalWindowContent({ modalType, data }),
        "#modal-window-container-holder",
      );
    }
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["button", "click"]];
  }

  onRendered() {
    const onTestSuccess = ()=>{

      this.onModalWindowSuccess({

        payload: {
          isOpenModal: true,
          modalType: "success",
          data: {}
        }

      })

    }

    const onTestMsg = ()=>{

      this.onModalMessageEvent({

        payload: {
          isOpenModal: true,
          modalType: "message",
          iconClass: "fa-circle-check",
          title: "You have been upgraded to Pro1.",
          data: {
            icon: "fa-circle-check",
            title: "You have been upgraded to Pro2."
          }
        }

      })

    }


    const onTestTOS = ()=>{

      this.onModalWindowTOS({

        payload: {
          isOpenModal: true,
          modalType: "tos",
          iconClass: "fa-circle-check",
          title: "You have been upgraded to Pro1.",
          data: {
            icon: "fa-circle-check",
            title: "You have been upgraded to Pro2."
          }
        }

      })

    }



    //window.setTimeout(onTestTOS, 3000);

   //console.log('modal container loaded ');

    //this.addChannel("CHANNEL_MODAL_WINDOW");
  }
}
